import { Link } from 'react-router-dom';

const footerNavLinks = [
  { name: '明星黑料', path: '/category/all' },
  { name: '网红吃瓜', path: '/category/all' },
  { name: '每日大赛', path: '/category/all' },
  { name: '视频爆料', path: '/category/all' },
];

const footerPolicyLinks = [
  { name: '隐私政策', path: '/privacy' },
  { name: '用户协议', path: '/terms' },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100 rounded-t-2xl mt-14">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
          <div className="md:col-span-5">
            <h4 className="text-3xl md:text-4xl font-heading font-bold text-background-50 mb-3">
              不错过每一个瓜
            </h4>
            <p className="text-foreground-400 text-sm mb-6 leading-relaxed max-w-md">
              订阅51爆料每日推送，第一时间获取最新最劲爆的网红明星黑料和独家爆料资讯。
            </p>
            <form
              id="footer-newsletter"
             
              className="flex flex-col sm:flex-row gap-2 max-w-md"
              onSubmit={(e) => {
                e.preventDefault();
                alert('订阅成功！感谢关注51爆料网。');
              }}
            >
              <input
                type="email"
                name="email"
                placeholder="输入您的邮箱地址"
                className="flex-1 bg-transparent border-b border-foreground-500 text-background-50 text-sm py-2 px-1 outline-none focus:border-primary-400 transition-colors placeholder:text-foreground-500"
                required
              />
              <button
                type="submit"
                className="px-5 py-2 bg-background-50 text-background-900 rounded-full text-sm font-medium hover:bg-primary-100 transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center gap-1"
              >
                订阅
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </button>
            </form>
          </div>

          <div className="md:col-span-3">
            <h5 className="text-sm font-semibold text-background-50 mb-4">快速导航</h5>
            <nav aria-label="页脚导航">
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-foreground-400 text-sm hover:text-background-50 transition-colors cursor-pointer underline decoration-foreground-600/30 hover:decoration-background-50">
                    首页
                  </Link>
                </li>
                {footerNavLinks.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-foreground-400 text-sm hover:text-background-50 transition-colors cursor-pointer underline decoration-foreground-600/30 hover:decoration-background-50"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
                <li>
                  <Link to="/about" className="text-foreground-400 text-sm hover:text-background-50 transition-colors cursor-pointer underline decoration-foreground-600/30 hover:decoration-background-50">
                    关于我们
                  </Link>
                </li>
              </ul>
            </nav>
          </div>

          <div className="md:col-span-4">
            <h5 className="text-sm font-semibold text-background-50 mb-4">联系我们</h5>
            <ul className="space-y-2 text-foreground-400 text-sm">
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line"></i>
                </span>
                400-888-5151
              </li>
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line"></i>
                </span>
                hello@heiliaobao.cn
              </li>
            </ul>
            <h5 className="text-sm font-semibold text-background-50 mt-5 mb-3">公司地址</h5>
            <p className="text-foreground-400 text-sm leading-relaxed">
              北京市朝阳区建国路88号<br />SOHO现代城A座1508室
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <a
              href="http://heiliaobao.cn/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-foreground-400 hover:text-background-50 transition-colors cursor-pointer underline decoration-foreground-600/30 hover:decoration-background-50 text-sm"
              aria-label="微博"
            >
              微博
            </a>
            <a
              href="http://heiliaobao.cn/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-foreground-400 hover:text-background-50 transition-colors cursor-pointer underline decoration-foreground-600/30 hover:decoration-background-50 text-sm"
              aria-label="抖音"
            >
              抖音
            </a>
            <a
              href="http://heiliaobao.cn/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-foreground-400 hover:text-background-50 transition-colors cursor-pointer underline decoration-foreground-600/30 hover:decoration-background-50 text-sm"
              aria-label="小红书"
            >
              小红书
            </a>
          </div>

          <p className="text-foreground-500 text-xs text-center">
            &copy; {new Date().getFullYear()} 51爆料网 版权所有
          </p>

          <div className="flex items-center gap-4">
            {footerPolicyLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="text-foreground-500 text-xs hover:text-background-50 transition-colors cursor-pointer"
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}